'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMinWidgetHeight = calculateMinWidgetHeight;

var _dimensions = require('../constants/dimensions');

function calculateMinWidgetHeight(_ref) {
  var showCloseButton = _ref.showCloseButton;

  var minHeight = _dimensions.SMALLEST_WIDGET_HEIGHT + _dimensions.SPACING_ABOVE_WIDGET;
  if (showCloseButton) {
    minHeight += _dimensions.CLOSE_BUTTON_AND_SPACING;
  }

  return minHeight;
}